export const FROZEN_CHAT_ERROR =
  'This chat cannot be continued because you no longer have access to the agent or it has been removed.';
